import { useState } from 'react';
import { Card, CardContent, Typography, Button, Box } from '@mui/material';
import EditEmployeeModal from './EditEmployeeModal';
import { formatDistanceToNow } from 'date-fns';
import { ru, uz } from 'date-fns/locale';

function formatSchedule(schedule) {
  const daysMap = {
    mon: 'Пн', tue: 'Вт', wed: 'Ср', 
    thu: 'Чт', fri: 'Пт', sat: 'Сб', sun: 'Вс'
  };
  
  return `
    ${schedule.workDays.map(d => daysMap[d]).join(', ')} 
    ${schedule.dailyHours.start}-${schedule.dailyHours.end} 
    (обед ${schedule.dailyHours.breakStart}-${schedule.dailyHours.breakEnd})
  `;
}

function formatPhoneNumber(phone) {
  if (!phone) return '';
  const cleaned = ('' + phone).replace(/\D/g, '');
  const match = cleaned.match(/^(\d{3})(\d{2})(\d{3})(\d{4})$/);
  if (match) {
    return `+${match[1]} ${match[2]} ${match[3]} ${match[4]}`;
  }
  return phone;
}

export default function EmployeeCard({ employee, refreshList }) {
  const [editOpen, setEditOpen] = useState(false);
  // Язык: из localStorage или узбекский по умолчанию
  const language = localStorage.getItem('language') || 'uz';
  const locale = language === 'ru' ? ru : uz;

  // Форматирование времени последнего входа
  const formatLastLogin = (dateString) => {
    if (!dateString) {
      return language === 'ru' ? 'Никогда не заходил' : 'Хеч қачон кирмаган';
    }
    return formatDistanceToNow(new Date(dateString), {
      addSuffix: true,
      locale,
    }) + (language === 'ru' ? ' вошёл' : ' кирган');
  };

  // Цвет статуса в зависимости от времени входа
  const getStatusColor = (lastLogin) => {
    if (!lastLogin) return 'error.main'; // Никогда не заходил
    const diffInHours = (new Date() - new Date(lastLogin)) / (1000 * 60 * 60);
    if (diffInHours < 1) return 'success.main'; // Онлайн в течение часа
    if (diffInHours < 24) return 'warning.main'; // Онлайн сегодня
    return 'text.secondary'; // Онлайн давно
  };

  return (
    <>
      <Card sx={{ minWidth: 275, m: 2, boxShadow: 3 }}>
        <CardContent>
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            @{employee.username}
          </Typography>
          <Typography color="text.secondary" sx={{ mb: 1 }}>
            {employee.name}
          </Typography>
          
          <Typography sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
            <Box
              component="span"
              sx={{
                width: 8,
                height: 8,
                borderRadius: '50%',
                bgcolor: getStatusColor(employee.lastLogin),
                mr: 1,
              }}
            />
            {formatLastLogin(employee.lastLogin)}
          </Typography>

          {employee.phone && (
            <Typography color="text.secondary" sx={{ mb: 1 }}>
              Телефон: {formatPhoneNumber(employee.phone)}
            </Typography>
          )}
          
          <Button
            onClick={() => setEditOpen(true)}
            variant="outlined"
            color="primary"
            sx={{ mt: 1, borderRadius: 2 }}
            fullWidth
          >
            Ўзгартириш
          </Button>
        </CardContent>
      </Card>

      <EditEmployeeModal
        open={editOpen}
        onClose={() => setEditOpen(false)}
        employee={employee}
        refreshList={refreshList}
      />
    </>
  );
}